import React, {Component} from 'react'

import HeaderUserbox from '../../../../layout-components/HeaderUserbox'

class NavRight extends Component {
  state = {
    listOpen: false,
  }

  render() {
    return (
      <>
        {/* <ul className='navbar-nav ml-auto'>
          <li>
          </li>
        </ul> */}
          <HeaderUserbox />
      </>
    )
  }
}

export default NavRight
